import {ChangeDetectionStrategy, Component, computed, inject, Signal} from "@angular/core";
import {MenuExtraGroupData, MenuItemData} from '../../../../menu/menu-entity.model';
import {navParam} from "../../../../navigation/navigation-params";
import {Page} from "../../../../navigation/page";
import {ButtonComponent} from "../../../../buttons/button/button.component";
import {ButtonProminence} from "../../../../buttons/button/button";
import {OrderItem} from '../../../order';
import {ModalPageLayoutComponent} from '../../../../page-layout/modal-page-layout/modal-page-layout.component';
import {
    OrderItemExtrasEditPanelComponent
} from "../order-item-extras-edit-panel/order-item-extras-edit-panel.component";
import {PageFooterControlDirective} from '../../../../page-layout/page-footer-control.directive';
import {MenuModel} from '../../../../menu/menu.model';

@Component({
    selector: "woa-order-item-combined-extras-edit-page",
    templateUrl: "./order-item-combined-extras-edit-page.component.html",
    styleUrl: "./order-item-combined-extras-edit-page.component.scss",
    providers: [{provide: Page, useExisting: OrderItemCombinedExtrasEditPageComponent}],
    imports: [
        ButtonComponent,
        ModalPageLayoutComponent,
        OrderItemExtrasEditPanelComponent,
        PageFooterControlDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderItemCombinedExtrasEditPageComponent extends Page {
    private menuModel: MenuModel = inject(MenuModel);

    ButtonProminence = ButtonProminence;

    public readonly orderItem: Signal<OrderItem> = navParam<OrderItem>("orderItem");
    public readonly mainOrderItem: Signal<OrderItem> = navParam<OrderItem>("mainOrderItem");
    public readonly originalOrderItem: Signal<OrderItem> = navParam<OrderItem>("originalOrderItem");
    public readonly menuItem: Signal<MenuItemData> = navParam<MenuItemData>("menuItem");
    public readonly promotedExtraGroup: Signal<MenuExtraGroupData> = navParam<MenuExtraGroupData>("promotedExtraGroup");

    public readonly title: Signal<string> = computed(() =>
        this.promotedExtraGroup() ? ("'" + this.menuModel.getExtraGroupDisplayName(this.promotedExtraGroup()) + "'") : "woa.heading.order.multiSelectExtrasEdit");

    changesMade: boolean = false;
}
